export enum DutyState {
  On = 'on',
  Off = 'off',
}

export enum DutyPresence {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  OffDuty = 'OffDuty',
}

export enum Readiness {
  Ready = 'Ready',
  NotReady = 'NotReady',
}

export enum UserState {
  Offline = 'Offline',
  OffDuty = 'OffDuty',
  Selectable = 'Selectable',
  NotSelectable = 'NotSelectable',
  Ringing = 'Ringing',
  Connected = 'Connected',
  AfterCallWork = 'AfterCallWork',
  Unknown = 'Unknown',
  Rona = 'Rona',
  DialingOut = 'DialingOut',
}
